import { createReducer } from '../../helpers/reducer';
import actions from './actions';
import { ILegalEntitiesOptionsState, ILegalEntityOption } from './types';

const initState: ILegalEntitiesOptionsState = {
  options: [],
  isLoading: false,
  isLoaded: false,
  hasError: false,
};

function onFetchRequest(state: ILegalEntitiesOptionsState) {
  return { ...state, isLoading: true, hasError: false };
}

function onFetchSuccess(state: ILegalEntitiesOptionsState, { payload }: { payload: ILegalEntityOption[] }) {
  return { ...state, options: payload, isLoading: false, isLoaded: true, hasError: false };
}

function onFetchError(state: ILegalEntitiesOptionsState) {
  return { ...state, options: [], isLoading: false, isLoaded: true, hasError: true };
}

export default createReducer(initState, {
  [actions.LEGAL_ENTITIES_OPTIONS_FETCH_REQUEST]: onFetchRequest,
  [actions.LEGAL_ENTITIES_OPTIONS_FETCH_SUCCESS]: onFetchSuccess,
  [actions.LEGAL_ENTITIES_OPTIONS_FETCH_ERROR]: onFetchError,
});
